import type { LiveServicesMapping } from './state';

export function getLiveServicesMappingByPhone(
  phoneNumber: string,
  mappings: readonly LiveServicesMapping[],
): LiveServicesMapping | undefined {
  return mappings.find((mapping) => mapping.phoneNumber === phoneNumber);
}

export function getLiveServicesMappingByPhoneAndTenant(
  phoneNumber: string,
  liveServicesTenantId: string,
  mappings: readonly LiveServicesMapping[],
): LiveServicesMapping | undefined {
  return mappings.find(
    (mapping) =>
      mapping.phoneNumber === phoneNumber &&
      mapping.tenantId === liveServicesTenantId,
  );
}

export function getLiveServicesTenantId(
  rtcsTenantId: number,
  phoneNumber: string,
  mappings: readonly LiveServicesMapping[],
): string {
  const mapping = getLiveServicesMappingByPhone(phoneNumber, mappings);
  // If no mapping is found, fall back to the raw numeric RTCS tenant ID. This is intentional —
  // the call will still be routed using the original Live Services tenant, per PM decision.
  return mapping ? mapping.tenantId : rtcsTenantId.toString();
}
